import React from 'react';
import { DropdownControl } from '@ver-uds/uswds-react';
import { useFormContext } from 'react-hook-form';
import { MarketingChannel } from 'eve-account-client';

export type FormValues = {
  marketingQuestionSecondary: string;
};

export interface MarketingQuestionSecondaryProps {
  data: MarketingChannel[] | undefined;
}

const MarketingQuestionSecondary = ({ data }: MarketingQuestionSecondaryProps): JSX.Element => {
  // eslint-disable-next-line @typescript-eslint/unbound-method
  const { register, errors } = useFormContext<FormValues>();

  const marketingQuestionSecondaryDropdown =
    data && data.length > 0 ? (
      <DropdownControl
        id="please-specify"
        name="marketingQuestionSecondary"
        className="tablet:grid-col-5 desktop:grid-col-5"
        label="Please Specify"
        required
        ref={register({
          required: {
            value: true,
            message: 'Please make a selection.',
          },
        })}
        errorId={errors.marketingQuestionSecondary && 'please-specify-error'}
        errorMessage={errors.marketingQuestionSecondary?.message}
      >
        <option value="">- Select -</option>
        {data?.map(({ code, displayName }) => (
          <option key={code} value={code}>
            {displayName}
          </option>
        ))}
      </DropdownControl>
    ) : (
      <></>
    );

  return marketingQuestionSecondaryDropdown;
};

export default MarketingQuestionSecondary;
